document.addEventListener('DOMContentLoaded', function () {
  var API_ENDPOINT = '/apps/rajasusu/api/claim-struk';
  var customerId = window.CLAIM_STRUK_CUSTOMER_ID;
  var form = document.getElementById('claim-struk-form');
  var submitBtn = document.getElementById('claim-struk-submit');

  if (!form) return;

  var i18n = window.CLAIM_STRUK_I18N || {};

  // Client-side rate limit: max 3 submissions per minute
  var submitTimestamps = [];
  var RATE_LIMIT = 3;
  var RATE_WINDOW = 60 * 1000;

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    var invoiceId = document.getElementById('invoice-id').value.trim();

    if (!invoiceId) {
      showFieldError('invoice-id-error', i18n.error_required || 'Invoice number is required.');
      return;
    }
    clearFieldError('invoice-id-error');

    // Remove timestamps older than 1 minute
    var now = Date.now();
    submitTimestamps = submitTimestamps.filter(function (t) { return now - t < RATE_WINDOW; });

    if (submitTimestamps.length >= RATE_LIMIT) {
      var waitSec = Math.ceil(RATE_WINDOW / 1000);
      window.showToast(
        (i18n.error_rate_limit || 'Terlalu banyak percobaan. Coba lagi dalam {sec} detik.').replace('{sec}', waitSec),
        'warning'
      );
      startCooldownButton(waitSec);
      return;
    }

    submitTimestamps.push(now);

    var originalText = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = i18n.processing || 'Processing...';

    try {
      var controller = new AbortController();
      var timeoutId = setTimeout(function () { controller.abort(); }, 15000);

      var response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ invoiceId: invoiceId, shopifyCustomerId: customerId }),
        signal: controller.signal,
      });
      clearTimeout(timeoutId);

      var result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.error || i18n.error_generic || 'Failed to process claim.');
      }

      if (result.status === false) {
        window.showToast(result.message || i18n.error_generic, 'error');
        return;
      }

      var pointMsg = result.point ? '\n' + (i18n.success_point || '').replace('{point}', result.point) : '';
      window.showToast((result.message || i18n.success_message) + pointMsg, 'success');
      form.reset();

    } catch (error) {
      var msg = error.name === 'AbortError'
        ? (i18n.error_timeout || 'Request timeout.')
        : error.message;
      window.showToast(msg, 'error');
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = originalText;
    }
  });

  var cooldownInterval = null;

  function startCooldownButton(seconds) {
    if (cooldownInterval) clearInterval(cooldownInterval);

    var btnLabel = submitBtn.dataset.originalLabel || submitBtn.textContent;
    submitBtn.dataset.originalLabel = btnLabel;
    submitBtn.disabled = true;

    var remaining = seconds;
    submitBtn.textContent = btnLabel + ' (' + remaining + ')';

    cooldownInterval = setInterval(function () {
      remaining--;
      if (remaining <= 0) {
        clearInterval(cooldownInterval);
        cooldownInterval = null;
        submitBtn.disabled = false;
        submitBtn.textContent = btnLabel;
        delete submitBtn.dataset.originalLabel;
      } else {
        submitBtn.textContent = btnLabel + ' (' + remaining + ')';
      }
    }, 1000);
  }

  function showFieldError(id, msg) {
    var el = document.getElementById(id);
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }

  function clearFieldError(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.textContent = '';
    el.hidden = true;
  }

});
